const dates = {
  date: 'Дата',
  today: 'Сегодня',
  yesterday: 'Вчера',
  tomorrow: 'Завтра',
  shortDays: 'дн.',
};

export default dates;
